export enum SHARE_LINK_TYPE {
    ads = 'ADS',
    request = 'REQUEST',
    newsAds = 'NEWSADS',
    userProfile = 'PROFILE'
}